import { defineMessages } from 'react-intl';

export default defineMessages({
    HomeDetails: {
        id: 'policy.common.component.policy-dwelling-info.Occupancy TypeN',
        defaultMessage: 'Home Details'
    },
    noScheduleItems: {
        id: 'portal.views.home-page-layout.No Scheduled Items available',
        defaultMessage: 'No Scheduled Items available'
    },
    coverageHeader: {
        id: 'portal.views.home-page-layout.Coverage',
        defaultMessage: 'Coverage'
    },
    descriptionHeader: {
        id: 'portal.views.home-page-layout.Description',
        defaultMessage: 'Description'
    }
});
